<template>
  <div>
    <div v-if="positiveBalanceMoreThaEnrollment && !payment_verified">
      <v-layout column justify-center align-center >
        <v-flex xs6>
          <v-alert type="info" :value="true">
            <h3>
              {{ $t(`enrollments.positive_balance_text`) }}
            </h3>
            <h4>
              {{ $t(`enrollments.pay_annuity_text`) }}
            </h4>
          </v-alert>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="hasPayrollPayment">
      <v-layout column justify-center align-center >
        <v-flex xs6>
          <v-alert type="success" :value="true">
            <h3>
              {{ $t(`enrollments.payroll_payment`) }}
            </h3>
          </v-alert>
        </v-flex>
      </v-layout>
    </div>
    <div v-else-if="no_payment_enrollment">
      <v-layout column justify-center align-center >
        <v-flex xs12>
          <v-alert type="info" :value="true">
            {{ $t(`enrollments.no_payment`) }}
          </v-alert>
        </v-flex>
      </v-layout>
    </div>
    <div v-else>
      <v-layout column justify-center align-center wrap>
        <v-flex xs4>
          <payment-proof
            v-if="payment_verified || payment_failed || payment_pending || payment_partial"
            :payment="payment_detail"
            :payment_detail="`${payment_detail.name}`"
          >
          </payment-proof>
        </v-flex>
        <v-flex xs4>
          <v-btn
            v-if="payment_partial || (payment_pending && enrollment_status.payment.partial)"
            :href="enrollment_status.payment.payment_url"
            :disabled="verification"
            :loading="verification"
            color="primary">{{ $t(`enrollments.complete_payment`) }}</v-btn>
          <v-btn
            v-if="payment_pending || payment_partial"
            @click="verifyPayment"
            :disabled="verification"
            :loading="verification"
            color="primary">{{ $t(`enrollments.validate_payment`) }}</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row justify-center align-center wrap>
        <v-btn v-if="payment_verified"
          color="primary"
          @click="downloadReceipt(null)">{{ $t(`enrollments.download_invoice`) }}</v-btn>
      </v-layout>
      <v-card
        class="mb-2 elevation-0"
        v-if="enrollment_costs && !payment_verified && (payment_failed || no_payment || payment_partial) && !payment_pending"
      >
        <v-layout justify-center row wrap>
          <v-flex xs12 sm5 md5 ma-2>
            <payment-component
              cost_to_pay="enrollment_payment"
              :step="4"
              :enrollment_costs="enrollment_costs"
              :other_concepts="other_concepts"
              :selected="cost_selected === 'enrollment_payment'"
              :extemp_enrollment="isExtempEnrollment"
              v-on:selectCost="selectPricing"
              :student="student"
              :saldo_favor="saldoFavor"
              :acquisition_price="acquisitionPrice"
              v-on:setTotal="setTotal"
              :saldo_favor_config="positiveBalanceStudent.balance"
              :fee="feeStudent"
              :ext_payment="extPaymentStudent"
              :payments_total="enrollment_status.payments_total"
              ></payment-component>
          </v-flex>
          <v-flex v-if="yearly_payment" xs12 sm6 md5 ma-2>
            <payment-component
              cost_to_pay="yearly_payment"
              :step="4"
              :enrollment_costs="enrollment_costs"
              :other_concepts="other_concepts"
              :selected="cost_selected === 'yearly_payment'"
              :extemp_enrollment="isExtempEnrollment"
              v-on:selectCost="selectPricing"
              :student="student"
              :saldo_favor="saldoFavor"
              :acquisition_price="acquisitionPrice"
              v-on:setTotal="setTotal"
              v-on:setTotalPay="setTotalYearly"
              :saldo_favor_config="positiveBalanceStudent.balance"
              :fee="feeStudent"
              :ext_payment="extPaymentStudent"
              :payments_total="enrollment_status.payments_total"
              :payment="payment_detail"
              ></payment-component>
          </v-flex>
        </v-layout>
        <v-layout v-if="hasAcquisitions" row wrap>
          <v-radio-group
            class="justify-center"
            :column="false"
            v-model="acquisition_id">
              <v-radio
                class="mt-2"
                v-for="(acq, i) in acquisitions"
                :key="`acq${i}`"
                color="primary"
                :label="acq.description"
                :value="acq.payment_method_id"
              ></v-radio>
          </v-radio-group>
        </v-layout>
        <v-layout v-if="!verification && !payment_verified" row justify-center mt-3>
          <v-btn v-if="payment_partial && cost_selected === 'yearly_payment'"
            :href="enrollment_status.payment.payment_url"
              color="primary"
              :loading="tcPayment"
              :disabled="tcPayment || !cost_selected || (hasAcquisitions && acquisition_id === '')"
          >
          {{ $t(`enrollments.complete_payment`) }}
          </v-btn>
          <v-btn v-else
              color="primary"
              @click="startPayment"
              :loading="tcPayment"
              :disabled="tcPayment || !cost_selected || (hasAcquisitions && acquisition_id === '')"
          >
          {{ $t(`enrollments.pay`) }}
          </v-btn>
          <v-btn v-if="hasSiesaReceipt"
            color="primary"
            @click="downloadReceipt(receipt.rowid_docto)">{{ $t(`enrollments.download_invoice`) }}</v-btn>
        </v-layout>
        <v-layout v-else column justify-center align-center mt-3>
          <v-flex  xs12>
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
              v-if="!payment_verified"
            ></v-progress-circular>
          </v-flex>
          <v-flex xs12 mt-3>
            <span class="font-weight-medium">{{ $t(`enrollments.verifying_payment`) }}</span>
          </v-flex>
        </v-layout>
      </v-card>
      <div
        v-else
      >
        <v-layout v-if="verification" column justify-center align-center mt-3>
          <v-flex xs12>
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-flex>
          <v-flex xs12 mt-3>
            <span class="font-weight-medium">{{ $t(`enrollments.verifying_payment`) }}</span>
          </v-flex>
        </v-layout>
        <v-alert
          :value="true"
          type="warning"
          v-else-if="!payment_verified && !payment_pending && !payment_partial"
        >
        {{ $t(`enrollments.no_costs`) }}
        </v-alert>
      </div>
    </div>
    <v-layout row wrap justify-center align-center mb-3 mt-2>
      <v-flex xs3 md1>
        <v-img contain :src="`${appUrl}/storage/img/payment/pse-min.jpg`"></v-img>
      </v-flex>
      <v-flex xs3 md1>
        <v-img contain :src="`${appUrl}/storage/img/payment/visa-min.webp`"></v-img>
      </v-flex>
      <v-flex xs3 md1>
        <v-img contain :src="`${appUrl}/storage/img/payment/Mastercard-min.jpg`"></v-img>
      </v-flex>
      <v-flex xs3 md1>
        <v-img contain :src="`${appUrl}/storage/img/payment/diners-min.jpg`"></v-img>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
     <v-layout row justify-center>
        <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
        <v-btn v-if="payment_verified || no_payment_enrollment || siesaCancelled || positiveBalanceMoreThaEnrollment || hasPayrollPayment" color="primary" @click="goToNextStep">{{ $t(`enrollments.next`) }}</v-btn>
      </v-layout>
      <v-dialog
        v-model="payment_dialog"
        width="600"
        persistent
      >
        <v-card>
          <v-card-title
            class="headline primary white--text"
            primary-title
          >
          {{ $t(`enrollments.payment_dialog_title`) }}
          </v-card-title>

          <v-card-text>
            {{ $t(`enrollments.payment_dialog_text`) }}
          </v-card-text>

        </v-card>
      </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Form from 'vform'
  import paymentProof from '../payment/proof'
  import PaymentComponent from './payment'
  export default {
    name: 'enrollment-step-4',
    components: {
      'payment-proof': paymentProof,
      'payment-component': PaymentComponent,
    },
    data() {
      return {
        isStaff : 0,
        formCosts: new Form({}),
        cost_selected: null,
        optionsCosts: [
            { value: 'enrollment_payment', text: 'Matrícula' },
            { value: 'yearly_payment', text: 'Matrícula y anualidad', disabled: false },
        ],
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        months_selected: 1,
        enrollment_costs: {
          enrollment_payment: 0,
          monthly_payment: 0,
          yearly_payment: 0
        },
        other_concepts: [],
        other_concepts_selected: {},
        verification: false,
        paymentErrorMessage: '',
        psePayment: false,
        tcPayment: false,
        payment_detail: {},
        no_payment_enrollment: false,
        payment_dialog: false,
        appUrl: window.config.appUrl,
        acquisitions: [],
        acquisition_id: '',
        total_to_pay: 0,
        total_enrollment: 0,
        total_yearly: 0,
        hasExternalPayment: false,
        hasPayrollPayment: false,
      }
    },
    created () {
      this.getCosts()
      this.getAcquisitions()
    },
    computed: {
      ...mapGetters({
        enrollment_id: 'currentEnrollmentId',
        enrollment_status: 'currentEnrollment',
        enrollment_status_id: 'currentEnrollmentStatusId',
        student: 'currentEnrollmentStudent',
        familyPortfolio: 'familyPortfolio',
        isExtempEnrollment: 'isExtempEnrollment',
        // hasExternalPayment: 'hasExternalPayment',
        externalPaymentDetail: 'externalPaymentDetail',
        receipt: 'receipt',
        hasPositiveBalance: 'hasPositiveBalance',
        positiveBalance: 'positiveBalance',
        hasFee: 'hasFee',
        fee: 'fee',
        yearly_payment: 'yearly_payment',
      }),
      payment_verified() {
        if (!this.enrollment_status.payment) {
          return false;
        }
        return this.enrollment_status.payment.payment_state === 'OK' || this.enrollment_status.payment.payment_state === 'APPROVED'
      },
      payment_failed() {
        if (!this.enrollment_status.payment) {
          return false;
        }
        return this.enrollment_status.payment.payment_state === 'FAILED' || this.enrollment_status.payment.payment_state === 'NOT_AUTHORIZED'
          || this.enrollment_status.payment.payment_state === 'REJECTED' || this.enrollment_status.payment.payment_state == '0' || this.enrollment_status.payment.payment_state == 'PARTIAL_EXPIRED'
      },
      payment_expired() {
        if (!this.enrollment_status.payment) {
          return false;
        }
        return this.enrollment_status.payment.payment_state == 'PARTIAL_EXPIRED'
      },
      payment_pending() {
        if (!this.enrollment_status.payment) {
          return false;
        }
        return this.enrollment_status.payment.payment_state === 'PENDING' || this.enrollment_status.payment.payment_state === 'iniciado'
      },
      payment_partial() {
        if (!this.enrollment_status.payment) {
          return false;
        }
        return this.enrollment_status.payment.payment_state === 'APPROVED_PARTIAL'
      },
      no_payment() {
        return this.enrollment_status.payment ? false : true
      },
      enrollment_discount() {
        let student_discount = 0
        if (this.student.descuento_1 > 0) student_discount = (this.enrollment_costs.enrollment_payment * (this.student.descuento_1 / 100))
        return Math.round(student_discount)
      },
      monthly_discount() {
        return Math.round((months_selected * this.enrollment_costs.monthly_payment) * (this.student.descuento_1 / 100))
      },
      yearly_discount() {
        return Math.round(this.enrollment_costs.yearly_payment * (this.student.descuento_1 / 100))
      },
      hasSiesaReceipt() {
        return this.receipt && this.receipt.rowid_docto
      },
      siesaCancelled() {
        return this.receipt && this.receipt.matricula_cancelada === 1
      },
      saldoFavor() {
        let saldo = 0

        /*if (this.receipt) {
          saldo = parseInt(this.receipt.valor_favor, 10)
        }*/

        return saldo
      },
      hasAcquisitions() {
        return this.acquisitions.length > 0
      },
      acquisitionPrice() {
        let price = 0

        if (this.hasAcquisitions) {
          const acqs = this.acquisitions.find(acq => acq.payment_method_id === this.acquisition_id)
          if (acqs) {
            price = acqs.price
          }
        }

        return price
      },
      positiveBalanceStudent() {
        let balance = 0
        const studentSearch = this.positiveBalance.find(pb => pb.student_id === this.student.id)
        if (studentSearch) {
          balance = studentSearch.positive_balance
        }

        return {
          balance,
          detail: studentSearch || []
        }
      },
      feeStudent() {
        let fee = 0
        const studentSearch = this.fee.find(f => f.student_id === this.student.id)
        if (studentSearch) {
          fee = studentSearch.fee
        }

        return {
          fee,
          detail: studentSearch || {}
        }
      },
      extPaymentStudent() {
        let amount = 0
        this.hasExternalPayment = false
        this.hasPayrollPayment = false
        const studentSearch = this.externalPaymentDetail.find(ep => ep.student_id === this.student.id)
        if (studentSearch) {
          this.hasExternalPayment = true
          amount = studentSearch.amount
          if ( studentSearch.payment_payroll) {
            this.hasPayrollPayment = true
          }
        }

        return {
          amount,
          detail: studentSearch || {}
        }
      },
      positiveBalanceMoreThaEnrollment() {
        let positive_balance_more_than_enrollment = false
        if (this.enrollment_costs) {
          positive_balance_more_than_enrollment = this.enrollment_costs.enrollment_payment + this.feeStudent.fee - this.enrollment_discount <= (this.positiveBalanceStudent.balance + this.saldoFavor + this.enrollment_status.payments_total + this.extPaymentStudent.amount)
        }
        return positive_balance_more_than_enrollment
      }
    },
    watch: {
      enrollment_status(newValue, oldValue) {
        if (newValue.documents) {
          this.getCosts()
        }

        if (!newValue.payment) {
          return
        }

        this.items = [];
        this.payment_detail = {
          name: newValue.enrollment.description,
          ...newValue.payment
        }

        if (!oldValue.payment || (oldValue.payment.payment_state !== 'PENDING' && oldValue.payment.payment_state !== 'APPROVED_PARTIAL' && oldValue.payment.payment_state != '0' && oldValue.payment.payment_state != 'iniciado')) {
          if (newValue.payment.payment_state === 'iniciado' || newValue.payment.payment_state === 'PENDING' || newValue.payment.payment_state === 'APPROVED_PARTIAL') {
            this.verifyPayment()
          }
        }
        if (this.enrollment_costs) {
          this.no_payment_enrollment = this.enrollment_costs.enrollment_payment === 0
        }
        this.setVerifycationErrorMessage(newValue.payment.payment_state)
      },
      enrollment_costs(newValue, oldValue) {
        if (newValue) {
          this.no_payment_enrollment = this.enrollment_costs.enrollment_payment === 0
        }
      }
    },
    methods: {
      // async getFamily() {
      //   const { data } = await axios.get(`/api/enrollment/start/getFamily/${this.student.family_id}`)
      //   this.family = data;
      // },
      async getCosts() {
        const { data } = await axios.get(`/api/enrollment/start/getCosts/${this.enrollment_id}/${this.enrollment_status.student_grade_enrollment}`)
        this.isStaff = data.is_staff;
        this.enrollment_costs = data.cost
        if(this.isStaff == 1){
          this.enrollment_costs.enrollment_payment = this.enrollment_costs.enrollment_diff_cost;
          this.enrollment_costs.monthly_payment = this.enrollment_costs.pensions_diff_cost;
        }
        this.other_concepts = data.other_concepts || []
      },
      getAcquisitions() {
        axios.get('/api/payment/acquisition/ENROLLMENTS')
          .then(resp => {
            if (resp.status === 200) {
              this.acquisitions = resp.data.acquisitions
            }
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      goToPrevStep() {
        this.$emit('goToPrevStep', 3)
      },
      goToNextStep() {

        if ((this.hasPayrollPayment || this.siesaCancelled || this.positiveBalanceMoreThaEnrollment) && !this.payment_verified) {
          const payment_to_use = this.extPaymentStudent.detail.length > 0
            && this.extPaymentStudent.detail.extemporaneous_id
          const payment_partial = this.payment_expired || this.payment_partial
          let total = 0
          if ( this.enrollment_costs ) {
            total = this.enrollment_costs.enrollment_payment + this.feeStudent.fee - this.enrollment_discount
          }
          let enrollment_cost_to_pay = 'enrollment_payment'
          if ( this.yearly_payment && this.total_yearly <= 0 ) {
            enrollment_cost_to_pay = 'yearly_payment'
          }
          const payload = {
            enrollment_id: this.enrollment_id,
            student_id: this.student.id,
            enrollment_status_id: this.enrollment_status_id,
            payment_to_use,
            hasExternalPayment: this.hasExternalPayment,
            hasPayrollPayment: this.hasPayrollPayment,
            payment_partial,
            total,
            enrollment_cost_to_pay,
            receipt: this.receipt && { ...this.receipt }
          }

          axios.post('/api/enrollment/useExternalPayment', payload)
            .then(resp => {
              if (resp.status === 200) {
                this.$emit('goToNextStep', 5)
              }
            })
            .catch(err => console.log(err))
        } else {
          this.$emit('goToNextStep', 5)
        }
      },
      async startPayment() {

        const { total, concepts } = this.getOtherConceptsTotal(this.cost_selected)
        const total_payment = this.total_to_pay
        if (total_payment <= 0) {
          return
        }
        this.tcPayment = true

        const payload = {
          enrollment_id: this.enrollment_id,
          student_id: this.student.id,
          enrollment_status_id: this.enrollment_status_id,
          total: total_payment,
          enrollment_cost_to_pay: this.cost_selected,
          concepts,
          receipt: this.receipt && { ...this.receipt },
          hasAcquisitions: this.hasAcquisitions,
          acquisition: this.acquisition_id,
          positive_balance: this.positiveBalanceStudent,
          fee: this.feeStudent,
          ext_payment: this.extPaymentStudent,
        }

        axios.post(`/api/enrollment/start/payEnrollment/ptp`, payload)
          .then(resp => {
            if (resp.status === 200) {
              if (resp.data.error) {
                this.$store.dispatch('responseMessage', {
                  type: 'error',
                  text: resp.data.message,
                  title: 'Error al iniciar pago',
                  modal: true
                })
                this.tcPayment = false;
                return;
              }
              this.payment_dialog = true;
              setTimeout(() => {
                this.payment_dialog = false;
                window.location = resp.data.url;
              }, 5000);
            } else {
              this.tcPayment = false;
            }
          })
          .catch(error => {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: 'Ha ocurrido un error al tratar de iniciar el pago, por favor intentelo de nuevo',
              title: 'Error al iniciar pago',
              modal: true
            })
            this.tcPayment = false;
            console.log(error)
          })

      },
      async verifyPayment() {
        this.verification = true

        axios.get(`/api/enrollment/start/verifyPayment/${this.enrollment_id}/${this.student.id}`)
          .then(resp => {
            if (resp.status === 200) {
              const { data } = resp;
              if(data.completed_verification) {
                const payload = {
                  enrollment_id: this.enrollment_id,
                  student_id: this.student.id,
                }
                this.$store.dispatch('fetchEnrollmentStatus', payload)
                if (data.estado_transaccion == 'OK' || data.estado_transaccion == 'APPROVED') {
                  // this.$emit('goToNextStep', 5)
                  this.verification = false
                  return;
                }

                const errorMessage = this.setVerifycationErrorMessage(data.estado_transaccion)

                this.$store.dispatch('responseMessage', {
                  type: data.estado_transaccion === 'PENDING' || data.estado_transaccion === 'APPROVED_PARTIAL' ? 'info' : 'error',
                  text: errorMessage,
                  title: 'El pago no ha podido ser verificado',
                  modal: false
                })
              } else {
                this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: result.data.message,
                  title: 'El pago no ha podido ser verificado',
                  modal: false
                })
              }
            }
            this.verification = false
          })
          .catch(error => {
            this.verification = false
          })
      },
      setVerifycationErrorMessage(status) {
        let errorMessage = ''

          switch (status) {
            case 'NOT_AUTHORIZED':
              errorMessage = 'El pago no fue autorizado'
              break;
            case 'PENDING':
              errorMessage = 'El pago se encuentra pendiente por validación'
              break;
            case 'iniciado':
              errorMessage = 'El pago se encuentra pendiente por validación'
              break;
            case 'FAILED':
              errorMessage = 'El pago no fue realizado'
              break;
            case 'REJECTED':
              errorMessage = 'El pago no pudo ser realizado'
              break;
            case 'APPROVED_PARTIAL':
              errorMessage = 'El pago ha sido aprobado parcialmente'
              break;

            default:
              errorMessage = 'El pago presentó errores'
              break;
          }
        this.paymentErrorMessage = errorMessage
        return errorMessage
      },
      getOtherConceptsTotal(payment_type) {
        const concepts = Object.keys(this.other_concepts_selected)
          .filter(concept => this.other_concepts_selected[concept])
          .map(concept => {
            const concept_value = concept.split('-')
            return {
              type: concept_value[0],
              concept_id: concept_value[1],
              price: concept_value[2],
            }
          })
          .filter(concept => concept.type === payment_type)


        const total = concepts
          .map(concept => this.other_concepts
              .filter(other_concept => other_concept.id == concept.concept_id)
              [0][payment_type]
          )
          .reduce((a, b) => a + b, 0)


        return {
          concepts,
          total,
        }

      },
      selectPricing(cost) {
        this.cost_selected = cost
      },
      setTotal(total) {
        this.total_to_pay = total
      },
      setTotalYearly(total) {
        this.total_yearly = total
      },
      downloadReceipt(rowid_docto = null) {
        let url = `/user/payment/proof/${rowid_docto}/ENROLLMENTS`
        if (!rowid_docto) {
          url = `/user/payment/proof/${this.payment_detail.id}`
        }

        axios({
            url,
            method: 'GET',
            responseType: 'blob'
          })
          .then(resp => {
            if (resp.status === 200) {

              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([resp.data]));
              link.setAttribute('download', `comprobante.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.loading = 0;
            }
          })
          .catch(error => {
            this.loading = 0;
            if (error.response.status === 404) {
              this.$store.dispatch('responseMessage', {
                  type: 'info',
                  text: 'Este servicio se ha pagado correctamente, pero el pago no ha sido generado en el sistema contable o bien la relación de este pago no existe en nuestro sistema. Por favor contacte el área de soporte',
                  title: 'Información',
                  modal: true
                })
            }
            console.log(error)
          })
      }
    },
  }
</script>

<style>
 .pricing-table{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
 }

 .pricing-table_title {
   color: white;
   padding: 15px 15px;
 }

 .pricing-table_footer, .pricing-table_content {
   padding: 15px;
 }

 .value {
   padding: 10px 5px;
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
 }

 .total {
   color: white;
   font-size: 20px;
   padding: 5px 15px;
 }

 .discount {
   font-size: 18px;
   color: white;
   padding: 5px 15px;
 }

 .label {
   font-weight: bold;
   font-size: 15px;
 }

 .price {
   font-weight: bold;
 }

 .pricing-table_footer {
   text-align: center;
 }

 .selected {
   animation: crecer 300ms ;
   transform: scale(1.04);
   border: solid 0.5px grey;
 }

 .extemp {
   color: brown;
   margin-top: -20px;
   font-size: 14px !important;
 }

 .v-input--radio-group__input {
   flex-wrap: wrap;
 }

 @keyframes crecer {
   0% {
     transform: scale(1);

   }
   100% {
     transform: scale(1.04);
   }
 }


</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step4.vue